export default "__VITE_ASSET__CsLdh1Ju__"